/**
 * AI（Gemini）の利用箇所の一覧 API サービス
 *
 * 初期値はバックエンドの api/config/ai_usages.py。プロンプト以外は設定画面から変えられる。
 */

import { apiClient } from '@/api/client'
import type { AiModelsResponse, AiUsageItem, AiUsageSetting, AiUsagesResponse } from '@/api/types/ai-usages'

/** 機能ごとのモデル・無料枠の扱い・有料のキーに切り替えるか・プロンプト */
export const getAiUsages = async (): Promise<AiUsagesResponse> => {
  const res = await apiClient.get<AiUsagesResponse>('/ai-usages')
  return res.data
}

/** 選べる Gemini のモデル一覧（取得に数秒かかるので、ページ本体とは別に引く） */
export const getAiModels = async (): Promise<AiModelsResponse> => {
  const res = await apiClient.get<AiModelsResponse>('/ai-usages/models')
  return res.data
}

/** モデルの順番・無料枠の扱い・有料のキーに切り替えるか・組み合わせを変える */
export const updateAiUsage = async (key: string, setting: AiUsageSetting): Promise<AiUsageItem> => {
  const res = await apiClient.put<AiUsageItem>(`/ai-usages/${encodeURIComponent(key)}`, setting)
  return res.data
}

/** 変えた値を消して初期値に戻す */
export const resetAiUsage = async (key: string): Promise<AiUsageItem> => {
  const res = await apiClient.delete<AiUsageItem>(`/ai-usages/${encodeURIComponent(key)}`)
  return res.data
}
